import {createStore, applyMiddleware, compose} from 'redux';
import rootReducer from '../rootreducer/index';
import thunk from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';

export default function configureStore(initialState) {
  return createStore(
    rootReducer,
    initialState,
      applyMiddleware(thunk,promiseMiddleware())
    );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js